import { render, staticRenderFns } from "./ApiAjax.vue?vue&type=template&id=0cf58c3c&scoped=true"
import script from "./ApiAjax.vue?vue&type=script&lang=js"
export * from "./ApiAjax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf58c3c",
  null
  
)

export default component.exports